import React from 'react';
import UseContext from "hooks/useContext";
import Divider from "../../../components/divider/divider";
import SectionWrapper, {FormField, textareaClassName} from "../components/SectionWrapper";

const Other = () => {
    const {data,setData}=UseContext()
    return (
        <SectionWrapper 
            title="Informations supplémentaires" 
            description="Profitez de cet espace pour préciser des informations supplémentaires que les candidats devraient avoir."
        >
            <FormField label="Informations pour le candidat sélectionné" optional>
                <textarea
                    name="other"
                    rows="5"
                    className={textareaClassName}
                    value={data.other}
                    maxLength={500}
                    minLength={3}
                    onChange={(e)=>{setData(prevData=>({...prevData,other:e.target.value}))}}
                ></textarea>
            </FormField>
            <Divider/>
            <FormField label="Informations pour l'agence d'intérim" optional>
                <textarea
                    name="other_interim"
                    rows="5"
                    className={textareaClassName}
                    value={data.other_interim}
                    maxLength={500}
                    minLength={3}
                    onChange={(e)=>{setData(prevData=>({...prevData,other_interim:e.target.value}))}}
                ></textarea>
            </FormField>
        </SectionWrapper>
    );
};

export default Other;
